import { useNavigate } from "react-router";
import TableColumn from "./columns";
import FilterMenu from "./filter-menu";
import { useEffect, useState } from "react";
import SummaryByStatus from "../../../components/summary-status/SummaryByStatus";
import API from "../../../services/api-request";
import { message, Table } from "antd";
import { useSearchParams } from "react-router-dom";
import "../../../assets/css/style-table.css";
import outboundPrint from "../../../components/print/outbound";
import { usePermissions } from "../../../utils/permissionUtil";

const Outbound = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const { hasCreatePermission, hasUpdatePermission } = usePermissions();

  const queryParams = Object.fromEntries([...searchParams]);
  const pagination = {
    current: parseInt(searchParams.get("page")) || 1,
    pageSize: parseInt(searchParams.get("limit")) || 10,
    total: totalData,
    onChange: (page, limit) => {
      pagination.current = page;
      pagination.pageSize = limit;
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("page", page);
      newSearchParams.set("limit", limit);
      setSearchParams(newSearchParams);
    },
  };

  const getOutbound = async (query) => {
    setData([]);
    const queryString = new URLSearchParams(query).toString();
    // Add default page and limit
    if (!searchParams.has("limit")) {
      searchParams.set("limit", 10);
    }
    if (!searchParams.has("page")) {
      searchParams.set("page", 1);
    }
    setSearchParams(searchParams);

    setLoading(true);
    API.Post(`transaction/outbound/list${query ? "?" + queryString : ""}`)
      .then((res) => {
        console.log(res);
        const page = query.page ? parseInt(query.page) - 1 : 0;
        const limit = query.limit ? parseInt(query.limit) : 10;

        setTotalData(res?.data?.data?.totalItems);

        const formatSelect = res?.data?.data?.data?.map((item, index) => {
          return {
            ...item,
            no: page * limit + index + 1,
          };
        });
        console.log("formatSelect", formatSelect);
        setData(formatSelect);
      })
      .catch((err) => {
        setData([]);
        message.info(`${err?.response?.data?.error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getSummary();
    if (queryParams) {
      getOutbound(queryParams);
    }
  }, [searchParams]);

  const handleNavigate = (data) => {
    navigate(`/outbound/detail/${data.id}`);
  };

  const handleStart = (data) => {
    navigate(`/outbound/start/${data.id}`);
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  const getSummary = async () => {
    try {
      const res = await API.Get(`transaction/outbound/summary`);
      console.log(res.data);
      setSummary(res?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handlePrint = (data) => {
    const printWindow = window.open("", "_blank", "width=800,height=600");

    printWindow.document.open();
    printWindow.document.write(outboundPrint(data));
    setTimeout(function () {
      printWindow.document.close();
    }, 2000);

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print({ showPrintDialog: true });

      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  return (
    <>
      <SummaryByStatus
        waiting_inbound={null}
        waiting_outbound={summary?.pending}
        approve={summary?.approve}
        done={summary?.done}
        reject={summary?.reject}
        total={summary?.total}
      />
      <br />
      <FilterMenu />

      <Table
        style={{ maxWidth: "100%", overflow: "auto" }}
        rowClassName={rowClassName}
        columns={TableColumn(
          handleNavigate,
          handleStart,
          handlePrint,
          hasCreatePermission,
          hasUpdatePermission
        )}
        dataSource={data}
        rowKey={(dataSource) => dataSource.id}
        pagination={pagination}
        loading={loading}
        scroll={{ x: "max-content" }}
      />
    </>
  );
};

export default Outbound;
